'use client'

import React, { useEffect, useState } from 'react'
import { useGetVendorByListingIdLazyQuery } from 'graphql/generated/graphql'
import VendorCard from './VendorCard'
import { AuthRequired } from '@/components/authRequired'
import { getUniqueIngredients, sortByEnhancedThenDistance } from '@/lib/utils'
import { DirectoryIngredient } from 'graphql/generated/graphql'

const PREVIEW_COUNT = 4
const GATE_THRESHOLD = 4

interface VendorPreviewProps {
  listingId: number
  listingName?: string
  followerCount?: number
}

const VendorPreview: React.FC<VendorPreviewProps> = ({ listingId, listingName, followerCount }) => {
  const [vendors, setVendors] = useState<any[]>([])
  const [getVendors, { loading }] = useGetVendorByListingIdLazyQuery({ fetchPolicy: 'no-cache' })

  useEffect(() => {
    if (!listingId) return
    getVendors({ variables: { listingID: listingId } }).then((res) => {
      const sorted = [...(res.data?.getVendorByListingID || [])].sort(sortByEnhancedThenDistance)
      setVendors(sorted)
    })
  }, [listingId])

  const total = vendors.length
  const preview = total > GATE_THRESHOLD ? vendors.slice(0, PREVIEW_COUNT) : []

  return (
    <>
      {preview.length > 0 && (
        <div className="mt-4">
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            {preview.map((vendor: any) => (
              <VendorCard
                key={vendor.listing_id}
                id={vendor.listing_id}
                userId={vendor.user?.user_id}
                image={vendor.photo}
                name={vendor.name}
                tagLine={vendor.tagLine}
                slug={vendor.slug}
                city={vendor.city}
                state={vendor.state}
                ingredients={getUniqueIngredients(
                  vendor.ingredients?.map((i: DirectoryIngredient) => i?.type)
                )}
                isDeletable={false}
                deleteVendors={() => {}}
                membership_type={vendor.membership_type}
              />
            ))}
          </div>
          {total > PREVIEW_COUNT && (
            <p className="mt-3 text-center text-sm text-gray-400">
              +{total - PREVIEW_COUNT} more vendors
            </p>
          )}
        </div>
      )}
      <AuthRequired
        listingName={listingName}
        listingType="market"
        tab="vendors"
        followerCount={followerCount}
        totalCount={total > GATE_THRESHOLD ? total : undefined}
      />
    </>
  )
}

export default VendorPreview
